import { Dedication } from 'models/Dedication'
import { useDispatch, useSelector } from 'react-redux'
import { RootState, TypedDispatch } from 'redux/store'
import orderDedicationSlice from './order-dedication-slice'
import { useMemo } from 'react'
import { createDedication } from '../../../../redux/services/dedication'

const useOrderDedication = () => {
  const dispatch = useDispatch<TypedDispatch<RootState>>()
  const state = useSelector((state: RootState) => state.order.dedication)

  const { confirmationId, confirmationToken } = useSelector(
    (state: RootState) => state.order.transaction,
  )

  return useMemo(
    () => ({
      value: state,
      setValue: (value: Dedication) => {
        dispatch(orderDedicationSlice.actions.setValue({ ...value }))
      },
      clearValue: () => {
        dispatch(orderDedicationSlice.actions.clearValue())
      },
      save: (dedication: Dedication) => {
        if (!confirmationToken) return

        const transactionPayload = {
          type: dedication.type,
          honoree_name: dedication.honoreeFirstName,
          name: '',
          email_address: dedication.recipientEmailAddress,
          address: dedication.recipientAddress,
          city: dedication.recipientCity,
          state: dedication.recipientState,
          postal_code: dedication.recipientPostalCode,
          country: dedication.recipientCountry,
          is_gift_amount_msg_included: false,
          ecard_id: dedication.ecardId,
          ecard_message: dedication.ecardMessage,
          first_name: dedication.recipientFirstName,
          last_name: dedication.recipientLastName,
          honoree_first_name: dedication.honoreeFirstName,
          honoree_last_name: dedication.honoreeLastName,
          transactionId: String(confirmationId),
        }

        dispatch(
          createDedication.initiate({ ...transactionPayload, transactionToken: confirmationToken }),
        )
      },
    }),
    [confirmationId, confirmationToken, dispatch, state],
  )
}

export default useOrderDedication
